import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch,shallowEqual } from "react-redux";
import { withStyles } from "@mui/styles";
import { USER_LOGGED_IN,APPLICATION_INITIALIZED } from "@utils/Events/constants";
import { useStyles } from "./styles";
import AwsAmplifyApi from "@utils/AwsAmplifyApi";
import { APIEndpoints,APIPaths, fullUrl } from "@config/APIEndpoints";
import store from "@redux/Store";
const WIDGET_TYPE = {ZOHO:'zoho',FRESH_WIDGET:'freshWidget'}
const widgetState = { fw: false,fc:false,fcl:false,type:null,zw:false,zc:false };
const LAUNCH_TOGGLE_ZOHO_CHAT = 'LAUNCH_TOGGLE_ZOHO_CHAT';
const LAUNCH_TOGGLE_URL = process.env.REACT_APP_LR_LAUNCH_TOGGLE_URL
import { appConfig } from "@config/AppConfig";
const loadWidget=(defaultType)=>{
	const config = appConfig().config;
	if(!config){
		console.log("app config - not initialized");
		setTimeout(()=>{
			loadWidget(defaultType)
		},10)
		return;
	}
	console.log("app config - initialized");
    if(!config?.chatWidgetEnabled) return;
	/* let url = null;
	if(LAUNCH_TOGGLE_URL){
		let providerUrl = (new URLSearchParams(sessionStorage.provider_state || "")).get("lr_application_url")
		url = LAUNCH_TOGGLE_URL
		if(providerUrl){
			url = `${(new URL(providerUrl)).origin}${(new URL(LAUNCH_TOGGLE_URL)).pathname}`
		}
	} */
	console.log("launch-toggle-Url====",fullUrl("launch-toggles"))
	const loadWType = (type)=>{
		if (type == WIDGET_TYPE.ZOHO) {
			loadZoho();
		} else {
			loadFreshdesk();
		}
	}
	fetch(fullUrl("launch-toggles"))
	.then(function (r) {
		return r.ok?r.json():r.then(Promise.reject.bind(Promise));
	})
	.then(function (data) {
		loadWType(data?.global_enabled?.indexOf(LAUNCH_TOGGLE_ZOHO_CHAT)>-1?WIDGET_TYPE.ZOHO:WIDGET_TYPE.FRESH_WIDGET);
	})
	.catch(err=>loadWType(defaultType)); 
	//loadFreshdesk();
}
const getZohoTokenCallback = (successCallback, failureCallback)=>{
  try {
	console.log("getZohoTokenCallback start");
	const dispatch = store.dispatch
	const apiName = APIEndpoints.NHCUSERACCESSAPI.name;
	const apiPath = APIPaths.ZOHO_CHAT_TOKEN;
	dispatch(AwsAmplifyApi.get({apiName, apiPath})).then(res=>{
		console.log("getZohoTokenCallback");
		successCallback(res.data)
	}).catch(e=>{
		console.log("getZohoTokenCallback failed1",e);
		failureCallback(e);
	});
  } catch (error) {
	console.log("getZohoTokenCallback failed2",error);
	failureCallback(error);
  }
}
const loadZoho=()=>{
	console.log("loading zoho widget");
	widgetState.type = WIDGET_TYPE.ZOHO;
	if(window.zw) return;
	const script = document.createElement('script');
	script.type = 'text/javascript';
	script.defer = true;
	script.src = 'https://desk.zoho.com/portal/api/web/asapApp/401150000444764040?orgId=690654502';
	script.onload = function () {
			updateZohoStyle();
	};
	document.body.appendChild(script);
	widgetState.zw = true
}
const loadFreshdesk=()=>{
	widgetState.type = WIDGET_TYPE.FRESH_WIDGET;
	if(window.FreshWidget) return
	console.log("loading fresh Desk widget");
	const script = document.createElement('script');
	script.src = 'https://assets.freshdesk.com/widget/freshwidget.js';
	script.onload = function () {
			initFreshWidget();
	};
	document.body.appendChild(script);
}
const loadFreshChat=(cb)=>{
	if(window.fcWidget || widgetState.fcl) return;
	const script = document.createElement('script');
	script.src = 'https://wchat.freshchat.com/js/widget.js';
	script.onload = function () {
		console.log("loadFreshChat,window.fcWidget",!!window.fcWidget)
		initFreshChat(cb);
	};
	document.body.appendChild(script);
	widgetState.fcl = true;
	console.log("load FC");
}
const initChat = (isLoggedIn,cb)=>{
	console.log("init---chat",isLoggedIn,widgetState.type);
	if(!widgetState.type){
		setTimeout(()=>initChat(isLoggedIn,cb),1000);
		return;
	}
	if(isFreshChat()){
		const fcCB = ()=>{
			widgetState.fw && !isLoggedIn && showFreshWidgetBtn(0);
			isLoggedIn && widgetState.fw && window.fcWidget && fcWidget.isInitialized() && hideFreshWidgetBtn(0);
			console.log("initChat3 ",isLoggedIn,widgetState.fw,!!cb);
			cb?.()
		}
		initFreshWidget(false,()=>{
			isLoggedIn && initFreshChat(fcCB);
			console.log("initChat2 ",isLoggedIn,widgetState.fw);
		});
	}else{
		updateZohoStyle(isLoggedIn)
		isLoggedIn && initZohoLogin()
	}
	cb?.()
}
const initZohoLogin = ()=>{
	if(widgetState.zc) return;
	widgetState.zc = !!window.ZohoDeskAsapReady;
	console.log("initZohoLogin window.ZohoDeskAsapReady",!!window.ZohoDeskAsapReady);
	if(!widgetState.zc){
		setTimeout(()=>initZohoLogin(),100);
		return;
	}
	window.ZohoDeskAsapReady?.( () => {
        console.log('initZohoLogin');
		ZohoDeskAsap.invoke('login', getZohoTokenCallback);
	})
}
const updateZohoStyle = (isLogin=false,retry=5)=>{
	const btn = document.getElementById("zohohc-asap-web-button");
	if(btn){
		btn.classList.add("zoho-chat-btn")
		btn.classList.toggle("logged-in", Boolean(isLogin));
		console.log("updated Zoho Btn",retry)
	}
	else{
		retry >0 && setTimeout(()=>updateZohoStyle(isLogin,retry-1),100)
	}
}
const isFreshChat = ()=>widgetState.type == WIDGET_TYPE.FRESH_WIDGET
const isChatEnabled = (isLogin=false)=>isLogin && (isFreshChat()?widgetState.fc:true)
const hideChat = ()=>{
	if(isFreshChat()){
		window.fcWidget && fcWidget.isInitialized() && fcWidget.destroy();
		widgetState.fc = false;
		showFreshWidgetBtn();
	}
	else if(widgetState.zc){
		window.ZohoDeskAsapReady( () => {
			ZohoDeskAsap.invoke('logout');
		})
	}
}
const initFreshWidget=(forceInit=false,cb,retry=0)=>{
	if(!window.FreshWidget) {
		retry > 0 && setTimeout(()=>{
			console.log("retry initFreshWidget",retry)
			initFreshWidget(forceInit,cb,retry-1);
		},100)
		return;
	}
	(!widgetState.fw || forceInit) &&  FreshWidget.init("", {
                "queryString": "&widgetType=popup",
                "utf8": "✓",
                "widgetType": "popup",
                "buttonType": "image",
                "backgroundImage": "https://drpsdfsopx5b0.cloudfront.net/web/icons/support-widget-icon.png",
                "buttonText": "Support",
                "buttonColor": "white",
                "buttonBg": "#006063",
                "alignment": "3",
                "offset": `${window.innerWidth-50}px`,
                "formHeight": "500px",
                "url": "https://support.leadingreach.com"
            });
	console.log('FreshWidget init',forceInit,!!FreshWidget.iframe());
	widgetState.fw = !!FreshWidget.iframe();
	if(!widgetState.fw){
		FreshWidget.update();
		console.log('FreshWidget re-init',forceInit,!!FreshWidget.iframe());
		widgetState.fw = !!FreshWidget.iframe();
	}
	cb && cb();	
}	
const hideFreshWidgetBtn=(reInitWidget=3)=>{	
	const fwbtn = document.getElementById("freshwidget-button");
	fwbtn && (fwbtn.style.left="-100px");
	!fwbtn && reInitWidget> 0 && initFreshWidget(true,()=>hideFreshWidgetBtn(reInitWidget-1));
}
const showFreshWidgetBtn=(reInitWidget=3)=>{	
	const fwbtn = document.getElementById("freshwidget-button");
	fwbtn && (fwbtn.style.left=`${window.innerWidth-50}px`);
	!fwbtn && reInitWidget> 0 && initFreshWidget(true,()=>showFreshWidgetBtn(reInitWidget-1));
}	
const initFreshChat=(cb)=>{
	if(!window.fcWidget){
		loadFreshChat(cb);
		return;
	}
	!widgetState.fc && window.fcWidget && fcWidget.init({
		token:"b575051a-edd3-43a5-8343-d38cb5f2b12f",
		host: "https://wchat.freshchat.com",
        config: {
            headerProperty: {
                hideChatButton: true
            }
        }
	});
	widgetState.fc = !!window.fcWidget;	
	console.log("init Fresh Chat",widgetState.fc);
	hideFreshWidgetBtn();	
	cb?.()
}	
loadWidget(WIDGET_TYPE.FRESH_WIDGET);		
const Footer = React.memo(({ classes,footerClass,...opts} ) => {
	const { isLoggedIn } = useSelector(state => state.userReducer, shallowEqual);
	const [state,setState] = React.useState({chatWidgetEnabled:isChatEnabled(isLoggedIn),open:false});
	const stateRef = useRef({...state})
	const updateState = (newState)=>setState(prevState=>{
		const st = {...prevState,...newState}
		stateRef.current = st;
		return st;
	});
	const toggleChatWidget = (e)=>{
		e?.preventDefault();
		updateState({open:!state.open});
	}

	const showFreshWidget = (e)=>{
		e?.preventDefault();
		initFreshWidget();	
		FreshWidget.show();
		updateState({open:false});
	}	
	
	
	const showChatWidget = (e)=>{
		e?.preventDefault();
		fcWidget.open();
		updateState({open:false});
	}	

	useEffect(()=>{
		const postChatLoad = ()=>{
			console.log("post initChat",state.chatWidgetEnabled,widgetState.fc,!!window.fcWidget,isChatEnabled(true))
			stateRef.current.chatWidgetEnabled!=isChatEnabled(isLoggedIn) && updateState({chatWidgetEnabled:isChatEnabled(true),open:false});
		}
		const onUserLoggedIn = ()=>{
			//console.log("Footer:USER_LOGGED_IN",_app.u);
			initChat(true,postChatLoad);
		}
		/* initFreshWidget(false,()=>{
			widgetState.fw && !isLoggedIn && showFreshWidgetBtn(0);
			isLoggedIn && widgetState.fw && window.fcWidget && fcWidget.isInitialized() && hideFreshWidgetBtn(0);
		}); */
		initChat(isLoggedIn,postChatLoad);
		const sub = _app.events.subscribe({[USER_LOGGED_IN]: onUserLoggedIn,[APPLICATION_INITIALIZED]: onUserLoggedIn});
		return ()=>{
			_app.events.unsubscribe(sub);
		}
	},[])
	useEffect(() => {
		//isLoggedIn && console.log("showFreshWidgetBtn>>");
		if(state.chatWidgetEnabled && !isLoggedIn){
			//console.log("showFreshWidgetBtn");
			updateState({chatWidgetEnabled:false,open:false});
			hideChat();
		}
	}, [isLoggedIn])
	return (<>
		<div className={`${classes.footerContainer} page-footer ${footerClass || ''}`}>
			{/* <VersionDetail /> */}
			<p className={classes.footerDescription}>
				<a class="lr-link" href="https://leadingreach.com/terms-service" target="_blank">Terms of Service</a> 
				&nbsp;·&nbsp;
                <a class="lr-link" href="https://leadingreach.com/privacy-policy" target="_blank">Privacy Policy</a> 
				&nbsp;·&nbsp;LeadingReach is a trademark of Leading Reach, Inc. © {new Date().getFullYear()} All rights reserved.
				{/* <br/>
				Having trouble? Contact us 
				&nbsp;<a class="lr-link" onClick={showFreshWidget} href="#">here</a>,
				or check out our online
				&nbsp;<a class="lr-link" target="_blank" href="https://support.leadingreach.com">HelpDesk</a>. */}
			</p>
			{/* <div class="freshwidget-button fd-btn-bottom" style={{right: 50}}>
				<a href="javascript:void(0)" class="freshwidget-customimage">
					<img src="https://drpsdfsopx5b0.cloudfront.net/web/icons/support-widget-icon.png" alt="Support"/>
				</a>
			</div> */}
		</div>
		{state.chatWidgetEnabled && <div className={classes.chatWidget}>
			<div className="footer-support-text">
				SUPPORT
			</div>

			<div class={`freshdesk-help-icon toggle-support-widgets ${isFreshChat()?'':'visible-hidden'}`} onClick={toggleChatWidget}>
				<img src={`/static/images/support-${state.open ? "close" : "open"}.svg`}/>
			</div>
    
			{isFreshChat() && state.open && <div className="help-popup">

				<div class="help-panel help-chat" onClick={showChatWidget}>
					<div class="panel">
						<div class="panel-body">
							<h5>Chat Live</h5>
							<p>We're here to help with your questions or issues. Ask away!</p>
						</div>
					</div>
					<div class="freshdesk-help-icon">
						<img src="/static/images/chat.svg"/>
					</div>
				</div>

				<div class="help-panel help-desk" onClick={showFreshWidget}>
					<div class="panel">
						<div class="panel-body">
							<h5>Help Desk</h5>
							<p>Submit a help request or search our knowledge base.</p>
						</div>
					</div>
					<div class="freshdesk-help-icon">
						<img src="/static/images/help-desk.svg"/>
					</div>
				</div>

			</div>}
		</div>}
</>
	)
})

export default withStyles(useStyles)(Footer);
